import React from 'react';
import styled from 'styled-components';

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 16px;
  font-family: inherit;
  background-color: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #3498db;
    box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
  }
  
  &:disabled {
    background-color: #f9f9f9;
    cursor: not-allowed;
  }
  
  &::-webkit-calendar-picker-indicator {
    cursor: pointer;
  }
`;

interface DateInputProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  min?: string;
  max?: string;
  name?: string;
}

const DateInput: React.FC<DateInputProps> = ({
  value,
  onChange,
  required = false,
  disabled = false,
  min,
  max,
  name = ''
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <InputWrapper>
      <Input
        type="date"
        value={value}
        onChange={handleChange}
        required={required}
        disabled={disabled}
        min={min}
        max={max}
        name={name}
      />
    </InputWrapper>
  );
};

export default DateInput;